/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SemanticPathService } from '@spartacus/core';
import { OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomOrderConfirmationGuard {
  constructor(
    protected orderFacade: OrderFacade,
    protected router: Router,
    protected semanticPathService: SemanticPathService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const newOrder = {
      code: '001',
      created: new Date(),
      status: 'completed',
      totalItems: 5,
      totalPrice: {
        currencyIso: 'USD',
        formattedValue: '123.0',
        maxQuantity: 5,
        minQuantity: 1,
        value: 123,
      },
    };

    this.orderFacade.setPlacedOrder(newOrder);

    return this.orderFacade.getOrderDetails().pipe(
      map((orderDetails) => {
        if (orderDetails && Object.keys(orderDetails).length !== 0) {
          return true;
        } else {
          return this.router.parseUrl(this.semanticPathService.get('orders') ?? '');
        }
      })
    );
  }
}
